import type { FC } from 'react';
import type { VolatilitySurfaceProps } from './types';
import VolatilitySurfaceWidget from './volatility-surface-widget';
import { MarketDataProvider } from '../../../../providers/market-data/market-data-provider';
import { SnapshotProvider } from '../../../../providers/snapshot-provider';
import { VolMarketProvider } from '../../../../providers/vol-market-provider';
import { OverviewProvider } from '../../../../providers/overview-provider';

const VolatilitySurfaceWrapperProvider: FC<VolatilitySurfaceProps> = (props) => (
  <OverviewProvider providerKey={props.providerKey}>
    <MarketDataProvider providerKey={props.providerKey}>
      <SnapshotProvider providerKey={props.providerKey} tokenKey={props.tokenKey}>
        <VolMarketProvider providerKey={props.providerKey}>
          <VolatilitySurfaceWidget {...props} />
        </VolMarketProvider>
      </SnapshotProvider>
    </MarketDataProvider>
  </OverviewProvider>
);

export default VolatilitySurfaceWrapperProvider;
